import { createI18n } from 'vue-i18n'
import { useLocale } from '@/composables/useLocale'

type MessageContent = Record<string, unknown>
type LocaleModule = { default: MessageContent }

export const FALLBACK_LOCALE = 'en'

// eager: false（預設）→ Vite 自動將每個 JSON 拆成獨立 chunk
const localeModules = import.meta.glob<LocaleModule>('../lang/*/*.json')

const i18n = createI18n({
  legacy: false,
  locale: useLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  globalInjection: true,
  // 啟動時不傳入 messages，由 loadLocaleMessages() 動態注入
  messages: {}
})

/**
 * 動態載入指定語系的所有 domain 翻譯
 * - 只下載對應語系的 JSON chunk（如 tw.json），不載入其他語系
 * - 多次呼叫同一 locale 是安全的（內容會合併）
 * - 未來切換語系：await loadLocaleMessages('jp'); i18n.global.locale.value = 'jp'
 */
export async function loadLocaleMessages(locale: string): Promise<void> {
  const matched = Object.entries(localeModules).filter(([path]) => path.endsWith(`/${locale}.json`))

  await Promise.all(
    matched.map(async ([, load]) => {
      const mod = await load()
      const current = i18n.global.getLocaleMessage(locale) as MessageContent
      i18n.global.setLocaleMessage(locale, { ...current, ...mod.default })
    })
  )
}

export default i18n
